import React from 'react';
import { Card, BarChart, Flex, Legend } from '@tremor/react';

export default function RespVsWlQuickVisual() {
  // Data for the quick visual comparison
  const comparisonData = [
    {
      category: "Government Grants",
      RESP: 100,
      "Whole Life": 0,
      Hybrid: 70
    },
    {
      category: "Flexibility",
      RESP: 30,
      "Whole Life": 100,
      Hybrid: 85
    },
    {
      category: "Longevity",
      RESP: 35,
      "Whole Life": 100,
      Hybrid: 100
    },
    {
      category: "Tax Efficiency",
      RESP: 70,
      "Whole Life": 85,
      Hybrid: 90
    }
  ];

  return (
    <Card className="mt-4 mb-8 bg-gradient-to-br from-blue-50 to-green-50 border border-blue-100">
      <div>
        <h3 className="text-center text-blue-800 text-xl font-semibold mb-1">At a Glance: Your Options</h3>
        <div className="text-center text-blue-600 mb-4">
          Comparing key features (higher is better)
        </div>
      </div>
      
      <Flex className="mt-4 mb-2 justify-center">
        <Legend
          className="max-w-lg"
          categories={["RESP", "Whole Life", "Hybrid"]}
          colors={["blue", "green", "purple"]}
        />
      </Flex>
      
      <BarChart
        className="h-60 mt-4"
        data={comparisonData}
        index="category"
        categories={["RESP", "Whole Life", "Hybrid"]}
        colors={["blue", "green", "purple"]}
        valueFormatter={(number) => `${number}%`}
        layout="vertical"
        showGridLines={false}
        showAnimation={true}
        showLegend={false}
      />
    </Card>
  );
}
